import React from 'react';
import { css } from '@emotion/css';
import styles from './styles.module.scss';

const CountrySelectOption = props => {
  const {
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerProps,
    data
  } = props;
  const { label, flag } = data;
  const styleImage = { backgroundImage: `url(${flag})` };
  return (
    <div
      className={cx(
        css(getStyles('option', props)),
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected
        },
        className
      )}
      {...innerProps}>
      <div className={styles.countryOption}>
        {flag && <div className={styles.flag} style={styleImage} />}
        <div>{label}</div>
      </div>
    </div>
  );
};

export default CountrySelectOption;
